module.exports = __webpack_public_path__ + "static/media/welding_2.3c5eff36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/welding_2.jpg
// module id = 1868
// module chunks = 0